module.exports = __webpack_public_path__ + "assets/filter-kosher-0726d6.svg";